module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imgpubl",
    staticStyle: {
      "margin-bottom": "-2.2em"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "1",
      "src": "images/1.jpg"
    }
  })]), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e122717"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Mark_9781595553966_epub_c18_r1#d6e3",
      "id": "d7e3"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Chapter 1")]), _c('br'), _c('br'), _vm._v("A MATTER OF DEATH AND LIFE "), _c('br'), _vm._v("Life Is Brief")])]), _vm._v(" "), _c('p', {
    staticClass: "extca",
    attrs: {
      "id": "d7e123817"
    }
  }, [_c('i', [_vm._v("No one can confidently say that he "), _c('br'), _vm._v("will still be living tomorrow.")])]), _vm._v(" "), _c('p', {
    staticClass: "extca",
    attrs: {
      "id": "d7e124817"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("—Euripides")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e125317"
    }
  }, [_c('span', {
    staticClass: "dcap2",
    attrs: {
      "id": "d14e583"
    }
  }, [_vm._v("D")]), _vm._v("uring the summer before my senior year in high school, I spent only a few days at home because my father had encouraged me to take a job with the Southwestern Company, selling books door-to-door. My dad was my hero, and I agreed to the work, unaware that it would mean thirteen-hour days for ten straight weeks with no breaks to see my family.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e128317"
    }
  }, [_vm._v("I hated being away from home. I especially hated that the time with Southwestern didn’t allow me to join my parents and six brothers and sisters on a weeklong Caribbean vacation. My father and I spoke each weekend by phone—he took great interest in my progress—but that was no substitute for being with him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e130918"
    }
  }, [_vm._v("I was back home that Friday in late August, just before classes started for my senior year, when he and I met for lunch at the headquarters of National Liberty Corporation, the life insurance company he had founded and led to considerable success. I was always so proud to be his son when I walked by his side through the beautiful home office. That day we talked about my plans for college and possibly for business later on.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e133618"
    }
  }, [_vm._v("The next day, Saturday, September 1, 1979, an ambulance sped to our home, where my father had been playing tennis with three other men, one of whom had rushed up to the house to make the emergency call. I didn’t think to worry. Lots of men fall out of breath during exercise. Dad was fifty-three and in the prime of life. I was sure he’d be back home in a few hours with a heart prescription and doctor’s orders to take it easy.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e136418"
    }
  }, [_vm._v("Instead, my mother and brothers and sisters and I gathered in the emergency room of the Bryn Mawr Hospital and listened to a doctor softly say, “I’m sorry. We did all we could.” My father was dead. My hero was gone. At age forty, my mother was a widow with seven children between ages eight and twenty-one. Certainly I had known people who had died during my still-young life; but death was supposed to happen to "), _c('i', [_vm._v("older")]), _vm._v(" people, in "), _c('i', [_vm._v("other")]), _vm._v(" families.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e140018"
    }
  }, [_vm._v("Shortly after we returned home from the hospital that day, my mother found a piece of paper on my father’s nightstand. He was a prolific note taker, never without pad and pen. In my mind, I can still see in his handwriting the words from the ninetieth Psalm: “"), _c('i', [_vm._v("So teach us to number our days, that we may present to You a heart of wisdom")]), _vm._v("” (v. 12 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NASB")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e143319"
    }
  }, [_vm._v("Arthur S. DeMoss was the wisest man I knew. Now he was in heaven, less surprised by his departure, I suspect, than we were. I still miss him. He never saw me play college football. His place was vacant when I married the most wonderful girl in the world. He missed greeting his first grandchildren. When I started a business, he wasn’t there to advise me—though I had more counsel from him than I realized at the time, which is a large reason for my writing this book.")]), _vm._v(" "), _c('p', {
    staticClass: "imgpub"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "9781595553546_INT_0019_001",
      "src": "images/9781595553546_INT_0019_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e146719"
    }
  }, [_vm._v("Seven years after my father’s death, in the spring of 1986, I was working for Rev. Jerry Falwell and attending a conference at the Opryland Hotel in Nashville. We had just settled into our rooms when a call came from home, telling me that my twenty-two-year-old brother, David, had been in a car accident and was in serious condition. Jerry and I checked out, flew to Philadelphia, and drove straight to the University of Pennsylvania hospital.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e149419"
    }
  }, [_vm._v("My kid brother, a wiry go-getter with a remarkable knack for making friends, just home for the summer before his final year at Liberty University, lay comatose next to a row of blinking and beeping machines. His doctors talked with us, and our friend Jerry Falwell prayed with us. Eventually we walked out of the hospital and across the street to the hotel where we would stay for the next several days. On June 6, 1986, David Arthur DeMoss joined my father in heaven.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e152920"
    }
  }, [_vm._v("After my father died, I somehow believed that early death would pass over the rest of my family. Why I thought that, I don’t know: actuarial tables, common odds, maybe—but certainly not the Bible, because, if anything, it underscores life’s brevity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e154720"
    }
  }, [_vm._v("As I write this, I am a few years from my father’s age at his death and more than twice my brother’s age when he died. The math in my head is unavoidable. I have a wife and children. I’ve had the thrill and challenges of building a career. I’ve had adult years and all that comes with new eras in life—all things David never lived to experience.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e156920"
    }
  }, [_vm._v("In the early years of the church, the apostle James wrote to Christians in a distant city, “Yet you do not know what your life will be like tomorrow. You are just a vapor that appears for a little while and then vanishes away” (James 4:14 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NASB")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e158720"
    }
  }, [_vm._v("What is it about human nature that we so blithely presume we will have seventy or eighty years of health and life? The Creator guarantees not another breath. Jonny Williamson was a history teacher and soccer coach at the school where my children each attended thirteen years. He died Thanksgiving Day after an eight-month battle with colon cancer. Though just thirty-two years old, Coach Williamson’s influence on hundreds of young men and women who studied and played under him would be impossible to articulate in a book this brief. His brother, sixteen years his elder, spoke to a standing-room-only crowd at his memorial service. The brother was struck, he said, by something Jonny kept saying during their final days together. “I didn’t think it would be this soon.” He passed away perfectly at peace with his Lord, his brother reported, but he wanted one more semester, one more soccer season.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e164821"
    }
  }, [_vm._v("“Man’s days are determined,” the Old Testament figure Job said as he labored to grasp his own devastating loss and grief. “You have decreed the number of his months and have set limits he cannot exceed” (Job 14:5 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e166321"
    }
  }, [_vm._v("When my father died, I thought I could never ever hurt that way again. Then we lost my brother. Since then, I have been privileged to share the sorrow of other families during great loss, and I know deep inside what is important. People are. God is. Time is—important, fleeting, priceless.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e168121"
    }
  }, [_vm._v("Winston Churchill’s father died at age thirty-nine, and England’s future prime minister grew up expecting also to die young. In his first autobiography, the young Churchill credited his military exploits in India, including a dramatic escape atop a moving train, and in general his fearless first decades, to his awareness of the ticking clock.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e170722"
    }
  }, [_vm._v("My own father’s death at age fifty-three circled that age in my mind, a red mark made darker and more certain by David’s sudden death only a few years later. I’m never so lost in living that I don’t hear the clock tick or have an eye on the calendar—not in a paranoid sense, but with a sense of purpose. As surely as a father’s life imprints on a son, a father’s early death frames how his son takes on the future . . . how he looks at the past, and why he might write a book on wisdom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e173822"
    }
  }, [_vm._v("I cannot remember that my father ever wasted a minute. Not that all he did was work; he frequently played tennis or Monopoly with us, went swimming or took us to professional sporting events, including the Super Bowl eight months before he died. He was also a great conversationalist. It’s just that he didn’t waste time. He didn’t watch TV, and he went to bed at a reasonable hour—even with guests still in the living room. (“Turn out the lights when you leave,” he would say on his way upstairs.) He rose early each day. His strong sense of purpose and life fully included time to think, plan, dream, and pray.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e177522"
    }
  }, [_vm._v("We all are wise to invest life’s most precious commodity for the greatest return. When I die, whenever that moment comes, I hope my passing will echo the psalmist’s saying “Teach me to number my days, that I may present to You a heart of wisdom”—not least because my father’s life and death have shown me that it is possible.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ca809e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Mark_9781595553966_epub_c21_r1.vue
// module id = 75
// module chunks = 0